import { t } from 'i18next';
import { Path, UseFormSetError } from 'react-hook-form';

import { getTypedCRUDErrors } from './getTypedCRUDErrors';

export function onSetTypedCRUDErrors<T extends Record<string, any>>(
  e: any,
  setError: UseFormSetError<T>,
) {
  const errors = getTypedCRUDErrors(e);

  if (!errors?.length) {
    return;
  }

  errors.forEach((error) => {
    if (error?.message && error?.field) {
      setError(
        error.field as Path<T>,
        {
          type: 'custom',
          message: t(error.message),
        },
        { shouldFocus: true },
      );
    }
  });
}
